import { render, staticRenderFns } from "./Paddock.vue?vue&type=template&id=59d17c88&"
import script from "./Paddock.vue?vue&type=script&lang=ts&"
export * from "./Paddock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports